function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(19, 19, 19)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'winter-blue': 'rgb(90, 154, 192)','brown': 'rgb(146, 99, 69)','dark-grey': 'rgb(81, 71, 77)','bordeaux': 'rgb(103, 28, 56)','military-green': 'rgb(61, 59, 57)','blue': 'rgb(39, 61, 96)','camel-brown': 'rgb(146, 99, 69)','red': 'rgb(119, 42, 57)','marrone': 'rgb(185, 123, 77)','nero': 'rgb(0, 0, 0)','beige': 'rgb(255, 242, 230)','bianco': 'rgb(255, 255, 255)','blue-royale': 'rgb(0, 61, 184)','rosso': 'rgb(219, 14, 39)','azzurro': 'rgb(21, 187, 238)','avorio': 'rgb(250, 233, 217)','grigio': 'rgb(68, 67, 73)','classic-black': 'rgb(0, 0, 0)','passion-red': 'rgb(252, 63, 61)','sky-blue': 'rgb(46, 110, 232)','red': 'rgb(237, 0, 0)','sweet-pink': 'rgb(253, 171, 221)','carbon-black': 'rgb(13, 14, 17)','desert-grey': 'rgb(174, 164, 161)','black-yellow': 'rgb(255, 218, 71)','black-white': 'rgb(255, 255, 255)','black-red': 'rgb(237, 0, 0)','salvia': 'rgb(161, 174, 164)','pumpkin-spice': 'rgb(255, 123, 54)','milk-chocolate': 'rgb(110, 66, 55)','grey-stone': 'rgb(153, 147, 151)','white-peach': 'rgb(221, 210, 208)','cheesecake': 'rgb(236, 0, 77)','night-blue': 'rgb(20, 29, 68)','ocean-blue': 'rgb(0, 38, 181)','electric-blue': 'rgb(2, 72, 167)','ametista': 'rgb(225, 200, 242)','fire-red': 'rgb(182, 49, 46)','vaniglia': 'rgb(243, 225, 213)','acqua-marina': 'rgb(1, 231, 228)','plum': 'rgb(87, 36, 79)','scarlet-red': 'rgb(231, 40, 45)','demon-red': 'rgb(255, 36, 58)','pacific-blue': 'rgb(0, 109, 191)','dark-white': 'rgb(241, 245, 246)','jeans': 'rgb(45, 64, 94)','cherry-pink': 'rgb(255, 92, 143)','forest-green': 'rgb(1, 89, 93)','dark-white': 'rgb(110, 113, 112)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','colore',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
